module.exports = '<div>\n    {{ word.word }} <i>(n)</i>: {{ word.definition }}\n</div>';